import "../../css/UserPageStyle/profile.css"

function ProfileBodyLeft(props) {
    return (
        <div className="profile-body-left">
            {props.children}
        </div>
    )
}

export default ProfileBodyLeft;

